<template>
  <div>
    <div class="userMenu container">
      <div class="userPanel clearfix">
        <div class="user-sideBar">
          <el-menu class="el-menu-vertical-demo" :default-openeds="openeds" @open="handleOpen" @close="handleClose">
            <!-- 分销客户部分 -->
            <el-submenu index="1" v-if="$store.state.userInfo.role === 1">
              <template slot="title">
                <i class="el-icon-user-solid"></i>
                <span>用户中心</span>
              </template>
              <el-menu-item index="1-1">
                <router-link tag="a" to="/user/personal" href="javacript:;">个人中心</router-link>
              </el-menu-item>
              <el-menu-item index="1-2">
                <router-link tag="a" to="/user/myAccount" href="javacript:;">我的账户</router-link>
              </el-menu-item>
              <el-menu-item index="1-3">
                <router-link tag="a" to="/user/message/" href="javacript:;">
                  系统消息<el-badge class="mark" :value="msgNumber" />
                </router-link>
              </el-menu-item>
              <el-menu-item index="1-4" route>
                <router-link tag="a" to="/user/changePwd/" href="javacript:;">修改密码</router-link>
              </el-menu-item>
              <el-menu-item index="1-5" route>
                <router-link tag="a" to="/user/address/" href="javacript:;">收货地址</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2" v-if="$store.state.userInfo.role === 1">
              <template slot="title">
                <i class="el-icon-s-order"></i>
                <span slot="title">我的订单</span>
              </template>
              <el-menu-item route index="2-1">
                <router-link tag="a" to="/user/orderMain/1" href="javacript:;">订单列表</router-link>
              </el-menu-item>
              <el-menu-item route index="2-2">
                <router-link tag="a" to="/user/myorderBack" href="javacript:;">
                  退货列表
                  <!-- <el-badge class="mark" :value="backNumber" /> -->
                </router-link>
              </el-menu-item>
              <el-menu-item route index="2-3">
                <router-link tag="a" to="/user/myorderReturn" href="javacript:;">退款列表</router-link>
              </el-menu-item>
            </el-submenu>

            <!-- 供应商客户部分 -->

            <el-submenu index="3" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-user-solid"></i>
                <span slot="title">账户管理</span>
              </template>
              <el-menu-item route index="3-1">
                <router-link tag="a" to="/provider/accountInfo" href="javacript:;">账户信息</router-link>
              </el-menu-item>
              <el-menu-item route index="3-2">
                <router-link tag="a" to="/provider/accountBill" href="javacript:;">账单管理</router-link>
              </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="6" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-s-claim"></i>
                <span>退货</span>
              </template>
              <el-menu-item index="6-1">
                <router-link tag="a" to="/provider/orderBack" href="javacript:;">
                  退货统计
                </router-link>
              </el-menu-item>
            </el-submenu> -->
            <el-submenu index="6" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-s-claim"></i>
                <span>平台分销订单</span>
              </template>
              <el-menu-item index="6-3">
                <router-link tag="a" to="/provider/deliverySummary" href="javacript:;">预配送列表</router-link>
              </el-menu-item>
              <el-menu-item index="6-2">
                <router-link tag="a" to="/provider/mateBill" href="javacript:;">下载订单列表
                  <el-badge class="mark" :value="matebillUndownNumber" /></router-link>
              </el-menu-item>
              <el-menu-item index="6-1">
                <router-link tag="a" to="/provider/orderBack" href="javacript:;">退货统计</router-link>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="5" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-s-shop"></i>
                <span>库存管理</span>
              </template>
              <!-- <el-menu-item index="5-0">
                <router-link tag="a" to="/provider/supplierWarehouse" href="javacript:;">供货商管理</router-link>
              </el-menu-item> -->
              <el-menu-item index="5-0">
                <router-link tag="a" to="/provider/whProductStock" href="javacript:;">库存管理</router-link>
              </el-menu-item>
              <el-menu-item index="5-1">
                <router-link tag="a" to="/provider/uploadBook" href="javacript:;">上传书目</router-link>
             </el-menu-item>
              <el-menu-item index="5-2">
                <router-link tag="a" to="/user/bookLog" href="javacript:;">上传书目记录</router-link>
              </el-menu-item>
              <!-- <el-menu-item index="5-3">
                <router-link v-if="checkWhMember" tag="a" to="/provider/bookDown" href="javacript:;">书目下载</router-link>
                <router-link v-else tag="a" to="" @click.native="checkMemberStatus" href="javacript:;">书目下载</router-link>
             </el-menu-item> -->
              <el-menu-item index="5-4">
                <router-link v-if="checkWhMember" tag="a" to="/provider/eliminateKeywords" href="javacript:;">屏蔽关键词</router-link>
                <router-link v-else tag="a" to="" @click.native="checkMemberStatus" href="javacript:;">屏蔽关键词</router-link>
             </el-menu-item>
            </el-submenu>
            <el-submenu index="6" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-s-claim"></i>
                <span>供应商订单</span>
              </template>
              <el-menu-item index="6-1">
                <router-link tag="a" to="/provider/whOrderMain/2" href="javacript:;">
                  订单列表
                </router-link>
              </el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="4" v-if="$store.state.userInfo.role === 2">
              <template slot="title">
                <i class="el-icon-s-claim"></i>
                <span>配货单</span>
              </template> -->
              <!-- <el-menu-item index="4-1">
                <router-link tag="a" to="/provider/downMateBill" href="javacript:;">
                  下载今日配货单
                </router-link>
              </el-menu-item> -->
              <!-- <el-menu-item index="4-2">
                <router-link tag="a" to="/provider/mateBill" href="javacript:;">下载订单列表</router-link>
              </el-menu-item>
            </el-submenu> -->
            <el-menu-item index="7">
              <i class="el-icon-service"></i>
              <span slot="title">帮助</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAction } from "../../api/index";
export default {
  data() {
    return {
      msgNumber: 0,
      matebillUndownNumber: 0,
      backNumber: 0,
      url: {
        userMessageNewNum: "/users/userMessageNewNum",
        getMatebillUndownNumber: "/provider/undownloadCountBill",
      },
      openeds: ["1", "2", "3", "4", "5", "6"],
      timer: null, // 定时器句柄
      pollInterval: 30000, // 轮询间隔，默认30秒
    };
  },
  created() {
    this.$store.state.showH = true;
    this.$store.state.showF = true;
    this.getMenuBadge();
    this.startPolling()
    
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getMenuBadge() {
      if (this.$store.state.userInfo.role === 1) { 
        getAction(this.url.userMessageNewNum, {
          userId: this.$store.state.userInfo.id,
        }).then((res) => {
          if (res.data.success) {
            this.msgNumber = res.data.result * 1;
            //也可用vuex来绑定此数据
          }
        });
      }
      if (this.$store.state.userInfo.role === 2) {
        getAction(this.url.getMatebillUndownNumber, {
          whId: this.$store.state.userInfo.id,
        }).then((res) => {
          if (res.data.success) {
            this.matebillUndownNumber = res.data.result * 1;
          }
        });
      }
    },
    // 启动定时器
    startPolling() {
      // 保险起见，先清除可能存在的旧定时器
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.getMenuBadge()
      }, this.pollInterval)
    },

    // 停止定时器
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    checkMemberStatus() {
      this.$message.error("请联系客服，开通会员...");
    },
  },
  computed: {
    ...mapGetters(["isNaName", "checkWhMember"]),
  },
};
</script>
<style lang="scss">
$mainColor: #5cadff;
.userMenu {
  //   margin-bottom: 40px;
  .user-header {
    height: 40px;
    padding: 12px 0;
    box-sizing: border-box;
    color: #757575;
    span.el-breadcrumb__separator {
      margin: 0 8px;
    }
  }
  .userPanel {
    .user-sideBar {
      float: left;
      width: 13.5%;
      // height: 593px;
      // max-height: 593px;
      background-color: #fff;
      border-right: 1px solid #e6e6e6;
      .el-menu {
        border: none;
      }
    }
    .content {
      float: left;
      width: 86.4%;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0px 0px 0px 6px;
    }
  }
}
</style>
